import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import {
  startPatientAuth,
  patientAuthSuccess,
  patientAuthFailure,
} from '../../redux/slices/patientAuthSlice';
import { authenticateWithDob } from '../services/patientApi';

const DEFAULT_MESSAGE =
  'Authentication failed. Please check your date of birth and try again.';

export const usePatientAuth = () => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((s: RootState) => s.patientAuth);

  const authenticate = useCallback(
    async (resourceType: string, encodedResourceId: string, dob: string) => {
      dispatch(startPatientAuth());
      try {
        const response = await authenticateWithDob(resourceType, encodedResourceId, dob);
        dispatch(
          patientAuthSuccess({
            patientToken: response.patientToken,
            resourceType,
            encodedResourceId,
            patientInfo: response.patientInfo,
            practiceInfo: response.practiceInfo,
          })
        );
        return true;
      } catch (err: any) {
        dispatch(patientAuthFailure(err?.message || DEFAULT_MESSAGE));
        return false;
      }
    },
    [dispatch]
  );

  return { authenticate, loading, error };
};
